<template>
  <main>
    <div class="testimonials-header">
      <div class="header-title">Testimonials</div>
      <div class="header-subtitle">What our customers say</div>
    </div>

    <!-- Testimonial Sections -->
    <section class="section-item">
      <div class="section-col-1">
        <div class="testimonial-name">Paul Harris</div>
        <div class="stars"><Star /><Star /><Star /><Star /><Star /></div>
        <div class="testimonial-text">2 years on And still happy, enough said!</div>
        <div>
          <a
            class="google-link"
            href="https://www.google.com/search?client=firefox-b-d&q=slater+chartered+accountants#lrd=0x6d6d18b056b1d1a1:0x9656a32a136d45c6,1"
            target="_blank"
            >View on Google</a
          >
        </div>
      </div>

      <div class="section-col-2">
        <div class="testimonial-name">Fauster Murwira</div>
        <div class="stars"><Star /><Star /><Star /><Star /><Star /></div>
        <div class="testimonial-text">
          These guys rock. They are a big outfit but they provide highly personalized service.
          Highly recommended..
        </div>
        <div>
          <a
            class="google-link"
            href="https://www.google.com/search?client=firefox-b-d&q=slater+chartered+accountants#lrd=0x6d6d18b056b1d1a1:0x9656a32a136d45c6,1"
            target="_blank"
            >View on Google</a
          >
        </div>
      </div>
    </section>

    <section class="section-item">
      <div class="section-col-1">
        <div class="testimonial-name">Mary Andersen</div>
        <div class="stars"><Star /><Star /><Star /><Star /><Star /></div>
        <div class="testimonial-text">
          Cheers to the Slater team: financials so easy to understand once my books were completed
          there. Also good to be able to email and phone for advice anytime. And thanks for the
          chocolates at the front desk: my grandies love them.
        </div>
        <div>
          <a
            class="google-link"
            href="https://www.google.com/search?client=firefox-b-d&q=slater+chartered+accountants#lrd=0x6d6d18b056b1d1a1:0x9656a32a136d45c6,1"
            target="_blank"
            >View on Google</a
          >
        </div>
      </div>

      <div class="section-col-2">
        <div class="testimonial-name">Janet Oberholzer</div>
        <div class="stars"><Star /><Star /><Star /><Star /><Star /></div>
        <div class="testimonial-text">
          Slater accountant has all the attributes a great accountant should have. In my opinion he
          is definitely one of the best if not the best accountant in New Zealand. Top notch
          communication skills, have a solid grasp on ones business needs, he stays up to speed on
          the latest in accounting trends - what more could you ask for?
        </div>
        <div>
          <a
            class="google-link"
            href="https://www.google.com/search?client=firefox-b-d&q=slater+chartered+accountants#lrd=0x6d6d18b056b1d1a1:0x9656a32a136d45c6,1"
            target="_blank"
            >View on Google</a
          >
        </div>
      </div>
    </section>

    <section class="section-item">
      <div class="section-col-1">
        <div class="testimonial-name">Matt Cameron</div>
        <div class="stars"><Star /><Star /><Star /><Star /><Star /></div>
        <div class="testimonial-text">
          Brilliant accountants, excellent advise with a common sense approach
        </div>
        <div>
          <a
            class="google-link"
            href="https://www.google.com/search?client=firefox-b-d&q=slater+chartered+accountants#lrd=0x6d6d18b056b1d1a1:0x9656a32a136d45c6,1"
            target="_blank"
            >View on Google</a
          >
        </div>
      </div>

      <div class="section-col-2">
        <div class="testimonial-name">Mihitai Tamihana</div>
        <div class="stars"><Star /><Star /><Star /><Star /><Star /></div>
        <div class="testimonial-text">
          The prompt response from when I sent in our questionnaires, to having my accounts sent out
          to me to sign then having my refunds in my bank account was amazing. Truly a professional,
          fast, hard working team that make it happen for their clients.
        </div>
        <div>
          <a
            class="google-link"
            href="https://www.google.com/search?client=firefox-b-d&q=slater+chartered+accountants#lrd=0x6d6d18b056b1d1a1:0x9656a32a136d45c6,1"
            target="_blank"
            >View on Google</a
          >
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="cta-section">
      <div class="cta-title">Experience the Slater difference</div>
      <div class="cta-subtitle">Too busy to come to us? we can come to you!</div>
      <a href="/contact" class="cta-button">
        <div>Lets talk</div>
      </a>
    </section>
  </main>
</template>

<script setup>
import Star from '../components/Star.vue';

document.title = 'Testimonials - Slater';
</script>

<style scoped>
/* Header */
.testimonials-header {
  margin: 100px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header-title {
  margin-bottom: 30px;
  color: #213b55;
  font-size: 72px;
  font-weight: 600;
}

.header-subtitle {
  margin-bottom: 30px;
  color: #213b55;
  font-size: 27px;
}

/* Section */
.section-item {
  margin-top: 200px;
  display: flex;
}

.section-col-1,
.section-col-2 {
  display: flex;
  flex-direction: column;
}

.section-col-1 {
  width: 30vw;
  margin-left: 10vw;
}

.section-col-2 {
  width: 30vw;
  margin-left: 2vw;
}

/* Testimonial */
.testimonial-name {
  font-size: 25px;
  font-weight: 600;
  color: #213b55;
}

.stars {
  margin-top: 20px;
  display: flex;
}

.testimonial-text {
  color: #213b55;
  margin: 30px 0;
  font-size: 18px;
}

.google-link {
  text-decoration: underline;
  text-underline-offset: 2px;
  text-decoration-color: #13b5ea;
  font-weight: 600;
  font-size: 18px;
}

/* CTA Section */
.cta-section {
  margin: 200px 2vw;
  display: flex;
  flex-direction: column;
  background-color: #6fefc1;
  justify-content: center;
  align-items: center;
}

.cta-title {
  font-size: 51px;
  font-weight: 600;
  color: #213b55;
  margin-top: 50px;
  text-align: center;
  padding: 10px;
}

.cta-subtitle {
  font-weight: 500;
  color: #213b55;
  margin-top: 10px;
}

.cta-button {
  font-weight: 500;
  cursor: pointer;
  margin: 50px 0;
  background-color: #213b55;
  color: #fff;
  padding: 5px 20px;
  max-width: 200px;
  font-size: 20px;
  border-radius: 4px;
  text-align: center;
}

/* Responsive */
@media only screen and (max-width: 768px) {
  .section-col-2 {
    margin-left: 11vw;
  }
}

@media only screen and (max-width: 480px) {
  .header-title {
    margin-bottom: 15px;
    font-size: 50px;
  }

  .header-subtitle {
    font-size: 22px;
  }

  .section-item {
    margin-top: 100px;
    flex-direction: column;
    padding: 20px;
  }

  .section-col-1 {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }

  .section-col-2 {
    width: 100%;
    margin-left: 0;
  }
}
</style>
